import { createAsyncThunk } from "@reduxjs/toolkit";
import * as ValidateApi from "../../../api/twoFactorApi";
import { trackEvent } from "../../../utils/tracking";
import { TRACKING_EVENTS } from "../../../utils/trackingDefinitions";

export const sendCode = createAsyncThunk("twofactor/sendCode", async () => {
	try {
		const response = await ValidateApi.sendCode();

		if (response.isSuccess) {
			trackEvent({
				event: TRACKING_EVENTS.LOGIN.EVENT.USER_INTERACTION,
				target: TRACKING_EVENTS.LOGIN.APP,
				key: "action",
				value: TRACKING_EVENTS.LOGIN.EVENT.SMS_LOGIN_CODE_SENT,
			});
		}

		return {
			isSuccess: response.isSuccess,
			error: response.errors?.[0],
			result: response,
		};
	} catch (error) {
		return { error: "komid.general.network.error" };
	}
});

export const validateCode = createAsyncThunk(
	"twofactor/validateCode",
	async ({ smsCode, returnUrl }: { smsCode: string; returnUrl: string }) => {
		try {
			const response = await ValidateApi.validateCode({
				smsCode,
				returnUrl,
			});

			if (response.isSuccess) {
				trackEvent({
					event: TRACKING_EVENTS.LOGIN.EVENT.USER_INTERACTION,
					target: TRACKING_EVENTS.LOGIN.APP,
					key: "action",
					value: TRACKING_EVENTS.LOGIN.EVENT.SMS_LOGIN_CODE_VERIFIED,
				});

				window.location.href = response.returnUrl;
			} else {
				trackEvent({
					event: TRACKING_EVENTS.LOGIN.EVENT.USER_INTERACTION,
					target: TRACKING_EVENTS.LOGIN.APP,
					key: "action",
					value: TRACKING_EVENTS.LOGIN.EVENT.SMS_LOGIN_CODE_VERIFICATION_FAILED,
				});
			}

			return {
				isSuccess: response.isSuccess,
				error: response.errors?.[0],
				result: response,
			};
		} catch (error) {
			return { error: "komid.general.network.error" };
		}
	},
);
